export default "__VITE_ASSET__Ck$Y7rmh__"